// Compatibility shim for projects upgraded to Vue 2.7+.
// Some dependencies (e.g. vue-toastification/composition) still import from '@vue/composition-api'.
// Vue 2.7 includes Composition API exports in `vue`, so re-export them here.

export * from 'vue';

// Keep default export compatible with `Vue.use(VueCompositionAPI)` calls.
export default {
    install() {
        // no-op (Composition API is built-in for Vue 2.7+)
    },
};

